<template>
  <div v-loading="loading">
    <pt-page-title :title="`${title}订单`">
      <el-button v-if="!isEdit" type="primary" plain slot="on-right" :class="$style['created-button']" @click="goLotNew">创建批量订单</el-button>
    </pt-page-title>
    <pt-sell-order-form class="pt-sell-order-form__withData" ref="form" :value="currentForm" :isEdit="isEdit" :recollect="recollect" :hospital="hospital" :branch="branch"></pt-sell-order-form>
    <div class="button-div">
          <el-button type="primary" @click="save">保存</el-button>
          <el-button type="primary" plain @click="cancel">取消</el-button>
      </div>
  </div>
</template>

<script>
import PtSellOrderForm from './index'
export default {
  name: 'pt-sell-order-form__withData',
  components: {
    'pt-sell-order-form': PtSellOrderForm
  },
  computed: {
    form () {
      return this.$refs.form
    },
    isEdit () {
      return this.$route.params.isEdit !== 'false'
    },
    disabled () {
      return this.isEdit && this.currentForm.nextOrderAction !== 'LAB_SAMPLES_RECEIVED'
    },
    recollect () {
      return this.$route.query.recollect === 'true'
    },
    title () {
      if (this.recollect) {
        return '创建重采'
      }
      return this.isEdit ? '编辑' : '创建'
    }
  },
  data () {
    return {
      loading: false,
      currentForm: {

      },
      hospital: [],
      branch: []
    }
  },
  watch: {
    currentForm (val) {
      console.log('----------watch--', val)
    }
  },
  methods: {
    goLotNew () {
      this.$router.push('/batch-operation')
    },
    getHospital () {
      let data = {
        pageableParam: {
          page: 0,
          size: 9999
        }
      }
      this.$store.dispatch('getHospitalList', data).then(res => {
        let newArr = []
        res.data.forEach(item => {
          newArr.push({
            value: item.id,
            label: item.name
          })
        })
        this.hospital = newArr
      }).catch(err => {
        this.$message.error(err || '获取医院列表失败')
      })
    },
    getCompanyList () {
      let data = {
        type: 'AGENT',
        businessType: ['ADULT'],
        pageableParam: {
          page: 0,
          size: 9999
        }
      }
      this.$store.dispatch('getBranchCompanyList', data).then(res => {
        var newArr = []
        res.data.forEach(ele => {
          newArr.push({
            value: ele.id,
            label: ele.fullName,
            addresses: ele.addresses
          })
        })
        this.branch = newArr
      }).catch(err => {
        this.$message.error(err || '获取分/子公司列表失败')
      })
    },
    load (id) {
      this.loading = true
      this.$store.dispatch('getAdultOrderDetail', id).then((response) => {
        this.loadFailed = false
        this.loading = false
        let { order } = response
        this.currentForm = this.changeToForm(JSON.parse(JSON.stringify(order)))
      }).catch((error) => {
        this.loading = false
        this.loadFailed = true
        this.$message.error(error || '获取订单信息失败！')
      })
    },
    changeToForm (data) {
      let res = JSON.parse(JSON.stringify(data)) || {}
      // res.detectionPackageIds = (data.detectionPackageIds && data.detectionPackageIds[0]) || null
      res.collectTime = res.samples && res.samples.filter(e => res.sampleObjectId === e.sampleObjectId)[0].collectTime
      return res
    },
    change (form) {
      console.log('---------------form', form)
      if (!this.isEdit || this.recollect) {
        form.samples = [{ sampleId: form.sampleId, collectTime: form.collectTime, sampleType: form.currentSample.sampleType }]
      } else {
        console.log('form.collectTime', form.collectTime)
        let targetSample = form.samples.filter(e => form.sampleObjectId === e.sampleObjectId)[0]
        targetSample.collectTime = form.collectTime
        targetSample.sampleType = form.currentSample.sampleType
      }
      if (form.patient.reciveAddress) {
        let address = form.patient.reciveAddress
        form.patient.reportReceivingProvince = address.provinceName
        form.patient.reportReceivingCity = address.cityName
        form.patient.reportReceivingDistrict = address.districtName
        form.patient.provinceGbCode = address.provinceGbCode
        form.patient.cityGbCode = address.cityGbCode
        form.patient.districtGbCode = address.districtGbCode
        form.patient.reportReceivingAddress = address.postAddress
      }
      return form
    },
    save () {
      this.form.validate('form').then(form => {
        console.log('----------', JSON.parse(JSON.stringify(form)))
        this.loading = true
        let copyData = JSON.parse(JSON.stringify(form))
        !this.isEdit || this.recollect ? this.create(this.change(copyData)) : this.edit(this.change(copyData))
      })
    },
    cancel () {
      history.go(-1)
    },
    edit (formValue) {
      console.log(formValue)
      this.$store.dispatch('editAdultOrder', formValue).then(data => {
        this.loading = false
        this.$message.success('保存成功！')
        this.cancel()
      }).catch(errorMessage => {
        console.error(errorMessage)
        this.loading = false
        this.$message.error(errorMessage)
      })
    },
    create (formValue) {
      this.$store.dispatch('creatAdultOrder', formValue).then(data => {
        this.loading = false
        this.$message.success('创建成功！')
        this.cancel()
      }).catch(errorMessage => {
        console.error(errorMessage)
        this.loading = false
        this.$message.error(errorMessage)
      })
    }
  },
  created () {
    // 获取渠道列表
    this.getCompanyList()
    // 获取采集医院列表
    this.getHospital()
    if (this.isEdit) {
      this.load(this.$route.params.id)
    }
  }
}
</script>
<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.created-button{
  margin-left: 40PX;
}
</style>
